import { render, staticRenderFns } from "./promotionLevel.vue?vue&type=template&id=57203506&"
import script from "./promotionLevel.vue?vue&type=script&lang=js&"
export * from "./promotionLevel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports